// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2p2vA","checkboxCol":"Table_checkboxCol__1ummh","emailCol":"Table_emailCol__3XUzS","actionCol":"Table_actionCol__13DzL"};